export default "__VITE_ASSET__BXJtvhcG__"